import {useEffect, useRef, useState} from "react";
import compressImage from "../helpers/compressImage";
import {AiOutlineCloudUpload} from "react-icons/ai";

const ImageInput = ({onChange, label, ...rest}) => {
    const {required} = rest;
    const [selectedFile, setSelectedFile] = useState();
    const [preview, setPreview] = useState("");
    const fileRef = useRef();
    const triggerFileModal = () => {
        fileRef.current.click();
    };

    useEffect(() => {
        if (selectedFile) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(reader.result);
                onChange({
                    base64: reader.result,
                    type: selectedFile.type
                });

            };
            reader.readAsDataURL(selectedFile);
        } else {
            setPreview(null);
        }
    }, [selectedFile]);

    const handleChange = async (e) => {
        const file = e.target.files[0]
        if (file) {
            const compress = await compressImage(file);
            setSelectedFile(compress);
        }
    };

    return (
        <div className="flex flex-col items-start flex-1">
            <span
                className={`form-label ${required ? 'after:content-["*"] after:text-red-600/70' : ''}`}> {label} </span>
            <div className="flex flex-col w-full">
                <input
                    type="file"
                    accept="image/*"
                    className="opacity-0 absolute"
                    onChange={handleChange}
                    ref={fileRef}
                    {...rest}
                />
                <div
                    className="bg-white h-36 w-full  rounded rounded-lg border-2 border-gray-200 shadow-sm flex justify-center items-center pointer overflow-x-hidden "
                    onClick={triggerFileModal}
                >
                    {!preview && <AiOutlineCloudUpload className="text-gray-600 text-2xl"/>}
                    {preview && <img src={preview} className="object-fill h-36 w-full " alt="preview"/>}
                </div>


            </div>
        </div>
    );
}
export default ImageInput;